import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import * as appConfig from "appConfig";
import styles from "./DolbyCinema.module.scss";
import { useUi } from "@jelly/lesson";
import { messages } from "../../Introduction.messages";
import { useIntl } from "react-intl";

type DolbyCinemaModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const DolbyCinemaModal: React.FC<DolbyCinemaModalProps> = (props) => {
  const ui = useUi();
  const { formatMessage } = useIntl();

  return (
    <ui.Modal {...props}>
      <div className={styles.modal}>
        <div className={styles.titleContainer}>{formatMessage(messages.slide5Modal1Title)}</div>
        <img
          style={{ height: "auto", width: "100%" }}
          className={styles.speakersSetup}
          src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/introduction/slide5/dolby-cinema.jpg`}
          alt="feature-comparison"
        />
        <div className={styles.description}>{formatMessage(messages.slide5Modal1Description)}</div>
      </div>
    </ui.Modal>
  );
};
